import React from 'react'
import DatePicker from "react-datepicker";

// Components
import ErrorInputWrap from '../../../../utils/error-success/ErrorInputWrap';
import ErrorWrap from '../../../../utils/error-success/ErrorWrap'
import SuccessWrap from '../../../../utils/error-success/SuccessWrap'
import Button from '../../../../utils/Button'

// CSS
import "../../../../../css/forms/custom-checkbox.css";
import "../../../../../css/forms/datepicker.css";
// import AdminMassEmailSectorForm from './AdminMassEmailSectorForm';

const AdminNoticeEmailForm = (
    {data, loading, errors, success, handleInputChange, handleDateChange, handleCheckboxChange, handleSubmit}
) => {
    return (
        <div className="fieldset">
			<div className="title-label">Notice Email Options</div>
            
            <div className="fieldset-indent">
                <div className="form-field">
                    <label>Email Subject:</label>
                    <ErrorInputWrap error={errors.subject}>
                        <input 
                            type="text" 
                            id="subject"
                            value={data.subject || ''}
                            maxLength="500"
                            onChange={e => handleInputChange(e)}
                        />
                    </ErrorInputWrap>
                </div>
                <div className="form-field">
                    <label>Email Content:</label>
                    <ErrorInputWrap error={errors.content}>
                        <textarea 
                            id="content"
                            value={data.content || ''}
                            onChange={e => handleInputChange(e)}
                        />
                    </ErrorInputWrap>
                </div>
                <div className="form-field checkbox">
                    <div className={`custom-label checkbox-label`}>
                        <input
                            type="checkbox"
                            id="include_onhold"
                            value={data.include_onhold || 0}
                            checked={data.include_onhold || 0}
                            onChange={e => handleCheckboxChange(e)}
                        />
                        <label htmlFor="include_onhold">Include "On-hold" reviewers</label>
                    </div>
                </div>
				<div className="floated-field-container pt1">
                    <div className="form-field half-field">
                        <label>Notify how many days before site visit:</label>
                        <ErrorInputWrap error={errors.days_before}>
                            <input 
                                type="number" 
                                id="days_before"
                                value={data.days_before || ''}
                                onChange={e => handleInputChange(e)}
                            />
                        </ErrorInputWrap>
                    </div>
                </div>

                <div className="btn_container pt1">
                    {!!errors.general && (
                        <ErrorWrap animate={1}>{errors.general}</ErrorWrap>
                    )}
                    {success && <SuccessWrap>{success}</SuccessWrap>}

                    <Button
                        text="Save Options"
                        clickHandler={() => handleSubmit()}
                        isLoading={loading}
                    />
                </div>
            </div>

			{/* <div className="title-label pt1">Sectors</div>
            <div className="fieldset-indent">
                <div className="form-field">
                    <AdminMassEmailSectorForm 
                        errors={errors}
                        handleSectorCheckboxChange={(e) => handleSectorCheckboxChange(e)}
                    />
                </div>
            </div> */}
        </div>
    )
}

export default AdminNoticeEmailForm


// WEBPACK FOOTER //
// ./src/components/admin/reviews/reviews-email/notice-email/AdminNoticeEmailForm.js